<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
body {
  padding: 0;
  margin: 0;
  height: 100%;
}
#app {
  font-family: "Avenir", Helvetica, Arial, "宋体", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #484a4d;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/App.vue